const ReportIcon = ({ color = '#314158', width = '16px', height = '16px' }) => {
	return (
		<svg width={width} height={height} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path d="M2 2V12.6667C2 13.0203 2.14048 13.3594 2.39052 13.6095C2.64057 13.8595 2.97971 14 3.33333 14H14" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M12 11.3333V6" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M8.66699 11.332V3.33203" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
			<path d="M5.33301 11.332V9.33203" stroke={color} strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />
		</svg>
	);
};

export default ReportIcon;
